import {ChangeDetectionStrategy, Component} from "@angular/core";
import {GroupItemModel} from "../group.interface";
import {DialogBase} from "../../../../common/dialog/dialog.base";

interface HierarchySelectionDialogData {
    showAssets: boolean;
    showCheckboxes: boolean;
    selectedGroups: GroupItemModel[];
}

@Component({
    templateUrl: "./hierarchy-selection-dialog.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HierarchySelectionDialogComponent extends DialogBase<HierarchySelectionDialogData, {
    selectedGroups: GroupItemModel[]
}> {
    private selectedGroups: GroupItemModel[] = this.data.selectedGroups;

    cancel(): void {
        this.dialogRef.close();
    }

    save() {
        this.dialogRef.close({
            selectedGroups: this.selectedGroups,
        });
    }

    handleSelectionChange($event: GroupItemModel[]) {
        this.selectedGroups = $event;
    }
}
